module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'removed': _vm.item.checked
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.checked),
      expression: "item.checked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.item.checked) ? _vm._i(_vm.item.checked, null) > -1 : (_vm.item.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.item.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.item, "checked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.item, "checked", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.item.text) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00a01cdb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemComponent.vue
// module id = 54
// module chunks = 1